var _g, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollecting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0367 12.7207L15.6383 12.7303C14.9663 12.7303 14.3711 12.9607 13.9391 13.4023C13.4879 13.8535 13.2383 14.5063 13.2383 15.2455L13.2479 18.1735C13.2575 19.6423 14.2463 20.6599 15.6575 20.6599L19.0559 20.6503C19.7375 20.6503 20.3231 20.4199 20.7551 19.9879C21.2063 19.5367 21.4559 18.8839 21.4559 18.1447L21.4463 15.2167C21.4463 13.7479 20.4575 12.7207 19.0367 12.7207Z",
    fill: "#25B7FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9583 10.3882C14.3903 10.8106 14.9663 11.0314 15.6383 11.0314H19.0559C20.4959 11.0218 21.4559 10.0138 21.4559 8.5162L21.4463 5.8378C21.4463 4.369 20.4575 3.3418 19.0367 3.3418L15.6383 3.3514C14.9663 3.3514 14.3807 3.5818 13.9391 4.0234C13.4879 4.4746 13.2383 5.1274 13.2383 5.8666L13.2479 8.545C13.2575 9.2842 13.5071 9.937 13.9583 10.3882Z",
    fill: "#25B7FF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5794 16.5923H18.1154C18.5186 16.5923 18.8354 16.2756 18.8354 15.8723C18.8354 15.4787 18.5186 15.1523 18.1154 15.1523H16.5794C16.1858 15.1523 15.8594 15.4787 15.8594 15.8723C15.8594 16.2756 16.1858 16.5923 16.5794 16.5923Z",
    fill: "#25B7FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1154 5.77148H16.5794C16.1858 5.77148 15.8594 6.09788 15.8594 6.49148C15.8594 6.89468 16.1858 7.21148 16.5794 7.21148H18.1154C18.5186 7.21148 18.8354 6.89468 18.8354 6.49148C18.8354 6.09788 18.5186 5.77148 18.1154 5.77148Z",
    fill: "#25B7FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.01324 6.20508H5.61484C4.90444 6.21468 4.29964 6.47388 3.87724 6.91548C3.45484 7.36668 3.21484 7.98108 3.21484 8.72028L3.22444 17.9458C3.22444 18.685 3.47404 19.3378 3.92524 19.789C4.35724 20.2114 4.94284 20.4322 5.60524 20.4322H9.03244C10.4436 20.4226 11.4324 19.3858 11.4228 17.917V8.70108C11.4228 7.96188 11.1636 7.30908 10.7124 6.85788C10.2804 6.42588 9.67563 6.21468 9.01324 6.20508Z",
    fill: "#25B7FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.54812 10.3717H8.09372C8.48732 10.3717 8.81372 10.0548 8.81372 9.65164C8.81372 9.25804 8.48732 8.93164 8.09372 8.93164H6.54812C6.15452 8.93164 5.82812 9.25804 5.82812 9.65164C5.82812 10.0548 6.15452 10.3717 6.54812 10.3717Z",
    fill: "#25B7FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollecting);
export default __webpack_public_path__ + "static/media/Collecting.dbd50c6efc631cdde43f4e80806e0868.svg";
export { ForwardRef as ReactComponent };